
export default function TabsViewHandler(tabView) {
    const tabs = tabView.querySelectorAll(':scope > .tabs ul li');
    const contents = tabView.querySelectorAll(':scope > .tab-content');

    [].forEach.call(tabs, function (tab, index) {
        tab.addEventListener('click', function () {
            setActiveTab(index);
        });
    });

    function setActiveTab(activeIndex) {
        [].forEach.call(tabs, function (tab, index) {
            if (index === activeIndex) {
                tab.classList.add('active');
            } else {
                tab.classList.remove('active');
            }
        });

        [].forEach.call(contents, function (content, index) {
            if (index === activeIndex) {
                content.classList.add('active');
            } else {
                content.classList.remove('active');
            }
        });
    }
}
